<template>
  <div class="lang-switch">
    <div class="switch-btn" @click="popVisible = true">
      {{ selected && selected.label || 'English' }}
      <img src="https://vip.image.video.qpic.cn/vupload/20230516/b0bfe41684224104968.png" alt="" class="switch-icon">
    </div>
    <div class="switch-pop" v-if="popVisible">
      <div class="mask" @click="popVisible = false"></div>
      <div class="pop-content">
        <div class="languages">
          <div class="lang-item"
            :class="{active: curLang === item.value}"
            @click="changeLang(item)"
            v-for="item in languages"
            :key="item.value">
            {{ item.label }}
          </div>
        </div>
        <div class="cancel-btn" @click="popVisible = false">{{ $lang[36] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLang, getSupportLangs, saveLang } from 'src/util/lang';

export default {
  data() {
    return {
      curLang: getLang(),
      popVisible: false,
      languages: getSupportLangs(),
    };
  },
  computed: {
    selected() {
      return this.languages.find(item => item.value === this.curLang);
    },
  },
  created() {
    window.wetvLogin.configSet({
      lang: this.curLang,
    });
  },
  methods: {
    changeLang(item) {
      saveLang(item.value);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
.lang-switch {
  .switch-btn {
    color: #898EA3;
    font-size: 12px;
    font-weight: 400;
    position: absolute;
    top: 0;
    right: 0;
    background: #fff;
    height: 28px;
    padding-left: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 14px 0 0 14px;
    .switch-icon {
      width: 24px;
      height: 24px;
    }
  }
  .switch-pop {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2;
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 2;
    }
    .pop-content {
      background: #fff;
      border-radius: 16px 16px 0 0;
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      height: 313px;
      z-index: 3;
      display: flex;
      flex-direction: column;
      & > * {
        width: 100%;
      }
    }
    .languages {
      flex: 1;
      overflow: auto;
      &::-webkit-scrollbar {
        display: flex;
      }
    }
    .lang-item, .cancel-btn {
      height: 56px;
      font-size: 16px;
      line-height: 56px;
      text-align: center;
      font-weight: 400;
      color: #101010;
      &.active {
        color: #FF6022
      }
    }
    .cancel-btn {
      background: #F5F5F5;
    }
  }
}
</style>
